"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _Menu = _interopRequireDefault(require("cornerstone_ui_core/lib/components/Menu"));

var _IsAuthorized = require("cornerstone_ui_core/lib/components/IsAuthorized");

var _MenuMap = _interopRequireDefault(require("./MenuMap"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

// submenu keys of first level
var rootSubmenuKeys = [];

var _default = function _default(_ref) {
  var menus = _ref.menus,
      shortcutNavigationMenuOptions = _ref.shortcutNavigationMenuOptions,
      rest = _objectWithoutProperties(_ref, ["menus", "shortcutNavigationMenuOptions"]);

  var _useState = (0, _react.useState)(menus),
      _useState2 = _slicedToArray(_useState, 2),
      menuList = _useState2[0],
      updateMenuList = _useState2[1];

  var _React$useState = _react.default.useState([]),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      openKeys = _React$useState2[0],
      setOpenKeys = _React$useState2[1];

  var getAuthorizedMenus = function getAuthorizedMenus(menus) {
    var authorizedMenus = [];
    menus && menus.forEach(function (menu) {
      var subMenus = [];
      if (menu.subCategoryVOList && menu.subCategoryVOList.length > 0) subMenus = getAuthorizedMenus(menu.subCategoryVOList);

      if ((menu.pathUrl || subMenus.length > 0) && !menu.functionKey || (0, _IsAuthorized.isEntitled)({
        user: rest.user,
        perform: menu.functionKey
      })) {
        authorizedMenus.push({
          path: menu.pathUrl,
          title: menu.menuCategory || menu.subCategory,
          accessFns: [menu.functionKey],
          menus: subMenus
        });
        authorizedMenus.sort(function (a, b) {
          return a.title.localeCompare(b.title);
        });
      }
    });
    return authorizedMenus;
  };

  (0, _react.useEffect)(function () {
    var modifiedMenus = _toConsumableArray(menuList);

    shortcutNavigationMenuOptions && shortcutNavigationMenuOptions.forEach(function (s) {
      var authorizedMenus = getAuthorizedMenus(s.categoryVOList);

      if (modifiedMenus.find(function (m) {
        return m.title === s.option;
      })) {
        modifiedMenus.find(function (m) {
          return m.title === s.option;
        }).menus = authorizedMenus;
      } // If First level menu list has sub menus, store keys in collection for checking open menu item


      modifiedMenus.forEach(function (x, index) {
        if (x.menus && x.menus.length > 0 && rootSubmenuKeys.indexOf("item_" + index) === -1) {
          rootSubmenuKeys.push("item_" + index);
        }
      });
    });
    updateMenuList(modifiedMenus);
  }, [shortcutNavigationMenuOptions]);

  var onOpenChange = function onOpenChange(keys) {
    var latestOpenKey = keys.find(function (key) {
      return openKeys.indexOf(key) === -1;
    });

    if (rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
      setOpenKeys(keys);
    } else {
      setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
    }
  };

  return /*#__PURE__*/_react.default.createElement(_Menu.default, _extends({
    theme: "light",
    className: "side-menu",
    mode: "inline",
    openKeys: openKeys,
    onOpenChange: onOpenChange
  }, rest), (0, _MenuMap.default)({
    menus: menuList
  }));
};

exports.default = _default;